import styled from "styled-components";

export const StyledCollaboratorItem = styled.div<{
  $hasOnClick: boolean;
  $disabled?: boolean;
}>`
  opacity: ${(props) => (props.$disabled ? "0.7" : "1")};
  pointer-events: ${(props) => (props.$disabled ? "none" : "auto")};
  cursor: ${(props) => (props.$hasOnClick ? "pointer" : "inherit")};
  filter: ${(props) => (props.$disabled ? "grayscale(100%)" : "none")};
`;
